/** Placeholder codes created server-side for backfilled incomplete accounts. */
export const PLACEHOLDER_CODES = {
  country: "XX",
  department: "NR",
  profession: "NRXX"
} as const;

export const PHONE_PLACEHOLDER = "Non renseigné";

type PlaceholderKind = keyof typeof PLACEHOLDER_CODES;

type ReferentialItem = {
  "@id"?: string;
  code?: string;
};

export const isPlaceholderCode = (
  code: string | undefined | null,
  kind: PlaceholderKind
): boolean => code === PLACEHOLDER_CODES[kind];

export const filterOutPlaceholders = <T extends ReferentialItem>(
  items: T[],
  kind: PlaceholderKind
): T[] => items.filter(item => !isPlaceholderCode(item.code, kind));

/** Returns the IRI if it maps to a real (non-placeholder) referential entry. */
export const resolveNonPlaceholderIri = (
  iri: string | null | undefined,
  items: ReferentialItem[],
  kind: PlaceholderKind
): string | null => {
  if (!iri) {
    return null;
  }
  const item = items.find(entry => entry["@id"] === iri);
  if (!item || isPlaceholderCode(item.code, kind)) {
    return null;
  }
  return iri;
};

export const isRealPhoneNumber = (
  phone: string | null | undefined
): boolean => {
  const trimmed = phone?.trim() ?? "";
  return trimmed !== "" && trimmed !== PHONE_PLACEHOLDER;
};
